// purpose: Stores information that affects workflow generation.

import { create } from "zustand";
import type { WorkflowContext } from "../sendWorkflow/types/workflowContext";

/**
 * Purpose:
 * Stores information required to build workflows.
 *
 * Why:
 * Workflow conditions are separate from
 * customer-entered journey data.
 *
 * Responsibilities:
 * - Store workflow context
 * - Update workflow context
 *
 * Does NOT:
 * - Store customer data
 * - Store navigation state
 */
interface WorkflowContextStore {
  workflowContext: WorkflowContext;

  updateWorkflowContext: (
    context: Partial<WorkflowContext>
  ) => void;
}

const initialContext: WorkflowContext = {
  isExistingCustomer: false,
  amount: 0,
  countryHasStates: false,
  requiresSecondaryId: false,
  requiresAdditionalInfo: false,
};

export const useWorkflowContextStore =
  create<WorkflowContextStore>((set) => ({
    workflowContext: initialContext,

    updateWorkflowContext: (context) =>
      set((state) => ({
        workflowContext: {
          ...state.workflowContext,
          ...context,
        },
      })),
  }));